import { useEffect, useState } from 'react';

import { useGetLeadCaptureResourceIdForm } from '@vimeo/gctl-api/hooks/useLeadCaptureResourceIdForm';
import { ENTITY_TO_PATH_MAP, ENTITY_TYPE } from '@vimeo/lead-capture-widgets/exports/constants';
import { getLeadCaptureCookie } from '@vimeo/lead-capture/exports/helpers';
import { useViewer } from '@vimeo/viewer';

export const useLeadCaptureRegistration = (albumId?: number) => {
  const viewer = useViewer();

  const [leadUuid, setLeadUuid] = useState<string | null>(null);
  const { data, isLoading } = useGetLeadCaptureResourceIdForm(
    () => {
      if (!viewer || !albumId) return null;

      return {
        where: {
          resourceId: albumId.toString(),
          resourceType: ENTITY_TO_PATH_MAP[ENTITY_TYPE.SHOWCASE],
        },
        select: ['enabled'],
      };
    },
    {
      revalidateOnFocus: false,
      shouldRetryOnError: false,
    },
  );

  useEffect(() => {
    const leadCaptureCookie = getLeadCaptureCookie(albumId?.toString());
    if (leadCaptureCookie) {
      setLeadUuid(leadCaptureCookie);
    }
  }, [albumId]);

  return {
    registrationEnabled: !!data?.enabled && !leadUuid,
    registrationLoading: isLoading && !leadUuid,
    setLeadUuid,
  };
};
